import Performance from 'performance/components/Performance';

const routes = {
  path: 'performance',
  element: <Performance />
};

export default routes;
